(() => {
  const config = document.getElementById('AlmatarPortugueseUI');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const selector = '[data-almatar-wishlist-button]';
  const update = button => {
    const label = button.querySelector('[data-almatar-wishlist-label]');
    if (!label) return;
    const saved = button.dataset.wishlisted === 'true';
    const value = saved ? labels.wishlistSaved : labels.wishlistAdd;
    if (label.textContent !== value) label.textContent = value;
    if (button.getAttribute('aria-label') !== value) button.setAttribute('aria-label', value);
  };
  document.querySelectorAll(selector).forEach(update);
  const observer = new MutationObserver(records => {
    const buttons = new Set();
    for (const record of records) {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      const button = target?.closest(selector);
      if (button) buttons.add(button);
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches(selector)) buttons.add(node);
        node.querySelectorAll(selector).forEach(item => buttons.add(item));
      }
    }
    buttons.forEach(update);
  });
  observer.observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['data-wishlisted']});
})();

